import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import ReconListRequest from "../request/ReconListRequest";

export const GetReconListApiService = async (request: any): Promise<any> => {

    const url = `/calendar_events/instances`;

    const { data } = await axios.get(`${url}?startTime=${request.startTime}&endTime=${request.endTime}&employerId=${request.employerId}`);
    return data;
};


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useReconEventInstanceListApiService = (request: ReconListRequest) =>
    useQuery<Promise<any>, AxiosError, any>(
        ["ReconEventInstanceListApiService", request.startTime,request.endTime, request.employerId], () =>
        GetReconListApiService(request),{keepPreviousData: true}
    );

export default useReconEventInstanceListApiService;
